module.exports = __webpack_public_path__ + "img/bg2.2f122284.jpg";